import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useNotifyError } from "./useNotifyError";
import { firstValueFrom, map, tap } from "rxjs";
import claimService from "services/claimService";
import { claims$ } from "services/subjects";
import { yyyyddmmTommddyyyy } from "common/utility";
import { ExtendedMemberClaim } from "types/ExtendedMemberClaim";

export const useClaims = (): UseQueryResult<ExtendedMemberClaim[], Error> => {
  const query = useQuery({
    queryKey: ["claims"],
    queryFn: () => {
      return firstValueFrom(
        claimService.get$.pipe(
          map((response) => response.response.results),
          map((results) =>
            results.map((result) => {
              return {
                ...result,
                service_date: result.claim_detail
                  ? `${yyyyddmmTommddyyyy(
                      result.claim_detail.service_from_date
                    )} - ${yyyyddmmTommddyyyy(
                      result.claim_detail.service_to_date
                    )}`
                  : "",
              };
            })
          ),
          tap((claims) => claims$.next(claims))
        )
      );
    },
  });

  useNotifyError(
    query.error,
    "An error occurred while loading your claims. Please try again later."
  );

  return query;
};
